import axios from 'axios'
import { useQuery } from 'react-query'

import { Entitlement, Feature, FeatureId, ProductSubscriptionBundleName } from './subscription'

export enum OrderType {
  ONBOARD = 'ONBOARD',
  OFFBOARD = 'OFFBOARD',
  CHANGE_PRODUCT = 'CHANGE_PRODUCT',
  UPSELL = 'UPSELL',
}

export enum OrderStatus {
  CANCELED = 'CANCELED',
  EXECUTING = 'EXECUTING',
  COMPLETED = 'COMPLETED',
}

export interface Order {
  id: string
  type: OrderType
  status: OrderStatus
  target_bundle_name: ProductSubscriptionBundleName
  added_entitlements: Entitlement[]
  removed_entitlements: Entitlement[]
  can_complete: boolean
  can_cancel: boolean
}

export function getOrders(teamId: string): Promise<Order[]> {
  const url = `/api/v1/console/orders/all/?team=${teamId}`
  return axios.get(url).then((response) => response.data)
}

export function createOrder(payload: {
  featureId: FeatureId
  name: Feature
  quantity: string
  immediate: boolean
  bypass_line_items: boolean
  team_id: string
}) {
  const url = `/api/v1/console/orders/upsell/`
  return axios.post(url, payload)
}

export function cancelOrder(id: string) {
  const url = `/api/v1/console/orders/${id}/cancel/`
  return axios.post(url)
}

export function completeOrder(id: string) {
  const url = `/api/v1/console/orders/${id}/complete/`
  return axios.post(url)
}

export function useOrders({ teamId, enabled = true }: { teamId: string; enabled?: boolean }) {
  const { data, isFetching, refetch, isLoading } = useQuery(`ORDERS-${teamId}`, () => getOrders(teamId), {
    enabled,
    cacheTime: 0,
    refetchOnWindowFocus: false,
    retry: true,
    retryDelay: (attempt) => Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000),
  })

  return {
    orders: data,
    refetch,
    isLoading,
    isFetching,
  }
}
